import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "coveo-logged-in-info__trigger-text"
};
const _hoisted_2 = {
  class: "coveo-logged-in-info__icon"
};
const _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CoveoAiIcon = _resolveComponent("CoveoAiIcon");
  const _component_CoveoAINotification = _resolveComponent("CoveoAINotification");
  return _openBlock(), _createBlock(_component_CoveoAINotification, {
    displayIcon: $data.displayIcon,
    isCoveoExpanded: $data.isCoveoExpanded,
    "onUpdate:isCoveoExpanded": _cache[0] || (_cache[0] = $event => $data.isCoveoExpanded = $event),
    componentStyle: "loggedIn",
    isFirstView: $data.isFirstView
  }, {
    "trigger-content": _withCtx(() => [_createElementVNode("p", _hoisted_1, _toDisplayString($data.triggerTitle), 1), _createElementVNode("span", _hoisted_2, [_createVNode(_component_CoveoAiIcon)])]),
    "panel-title": _withCtx(() => []),
    "panel-content": _withCtx(() => [_createElementVNode("p", {
      innerHTML: $data.contentDescription
    }, null, 8, _hoisted_3)]),
    _: 1
  }, 8, ["displayIcon", "isCoveoExpanded", "isFirstView"]);
}